module.exports = __webpack_public_path__ + "media/components/country-flag/static/va-52b056405c168adeecf370f42980aa2a.svg";